import { useMemo } from 'react'
import { useExecuteQueryBlueprintQuery, useDebugQueryBlueprintQuery } from '../../../../api/denali'
import { useParameterReplacementEx } from '../../../../hooks/useAbundanceEngineParameters'
import { useVariables } from '../../../../providers/VariableProvider'

const EMPTY_ARRAY = []

export default function useBlueprintData (blueprintCode, purposeCode, options = {}) {
  const {
    parameters = {},
    page,
    pageSize,
    sortBy,
    sortDirection,
    subordinatePredicates,
    filters,
    includeCount,
    scopePredicates,
    definition,
    definitionVersionId,
    enabled = true
  } = options

  const { variables } = useVariables()
  const [resolvedParams] = useParameterReplacementEx(parameters, variables)
  const useInlineDefinition = !!definition

  const request = useMemo(() => {
    if (!purposeCode) return null
    if (!useInlineDefinition && !blueprintCode) return null

    const req = {
      purposeCode,
      parameters: resolvedParams
    }

    if (useInlineDefinition) {
      req.definition = definition
    } else {
      req.code = blueprintCode
      if (definitionVersionId) req.definitionVersionId = definitionVersionId
    }

    if (page !== undefined) req.page = page
    if (pageSize !== undefined) req.pageSize = pageSize
    if (sortBy) {
      req.sortBy = sortBy
      if (sortDirection) req.sortDirection = sortDirection
    }
    if (subordinatePredicates?.length) req.subordinatePredicates = subordinatePredicates
    if (filters?.length) req.filters = filters
    if (includeCount) req.includeCount = true
    if (scopePredicates?.length) req.scopePredicates = scopePredicates

    return req
  }, [blueprintCode, purposeCode, resolvedParams, useInlineDefinition, definition, definitionVersionId, page, pageSize, sortBy, sortDirection, subordinatePredicates, filters, includeCount, scopePredicates])

  // Hooks rules: always call both, disable the inactive one via `enabled`.
  const inlineResult = useDebugQueryBlueprintQuery(request, {
    enabled: enabled && !!request && useInlineDefinition
  })
  const liveResult = useExecuteQueryBlueprintQuery(request, {
    enabled: enabled && !!request && !useInlineDefinition
  })
  const { data, isLoading, isFetching, error } = useInlineDefinition ? inlineResult : liveResult

  return {
    data: data?.data ?? EMPTY_ARRAY,
    metadata: data?.metadata ?? null,
    isLoading,
    isFetching,
    error
  }
}
